const DesktopClients = {
  ELECTRON: 'ELECTRON',
  DOTNET: 'DOTNET',
  NONE: 'NONE',
};

export default DesktopClients;
